import {
  solarAddCircleBroken,
  solarAlignLeftBroken,
  solarAltArrowDownBroken,
  solarAltArrowLeftBroken,
  solarAltArrowRightBroken,
  solarArrowLeftBroken,
  solarArrowRightBroken,
  solarBuildings2Broken,
  solarCalendarBroken,
  solarCameraBroken,
  solarChart2Broken,
  solarChartBroken,
  solarCheckBroken,
  solarCheckCircleBroken,
  solarChecklistBroken,
  solarClockCircleBroken,
  solarCloseBroken,
  solarCloseCircleBroken,
  solarCloudCrossBroken,
  solarCloudUploadBroken,
  solarCodeBroken,
  solarCompassBroken,
  solarCopyBroken,
  solarCrownBroken,
  solarDangerTriangleBroken,
  solarDisketteBroken,
  solarDocumentTextBroken,
  solarDownloadBroken,
  solarEyeBroken,
  solarEyeClosedBroken,
  solarForbiddenCircleBroken,
  solarGalleryBroken,
  solarGalleryCheckBroken,
  solarGlassesBroken,
  solarGlobalBroken,
  solarHamburgerMenuBroken,
  solarHeartBroken,
  solarHourglassBroken,
  solarInboxBroken,
  solarInfoCircleBroken,
  solarKeyBroken,
  solarLetterBroken,
  solarLinkBroken,
  solarLockKeyholeBroken,
  solarLogoutBroken,
  solarMagicStick3Broken,
  solarMagniferBroken,
  solarMapBroken,
  solarMapPointBroken,
  solarMaximizeBroken,
  solarMenuDotsBroken,
  solarMinimizeBroken,
  solarMonitorBroken,
  solarNotebookBroken,
  solarPenBroken,
  solarPenNewSquareBroken,
  solarPieChart2Broken,
  solarPlainBroken,
  solarQrCodeBroken,
  solarRefreshBroken,
  solarRestartBroken,
  solarSettingsBroken,
  solarShareBroken,
  solarShieldUserBroken,
  solarShopBroken,
  solarSquareArrowRightUpBroken,
  solarStarBroken,
  solarTagBroken,
  solarTicketBroken,
  solarTrashBinTrashBroken,
  solarTuning2Broken,
  solarUndoLeftBroken,
  solarUndoLeftRoundBroken,
  solarUploadBroken,
  solarUserBroken,
  solarUsersGroupRoundedBroken,
  solarVideocameraBroken,
  solarWidgetBroken,
} from '@spartan-ng/helm/icons';
import {
  lucideFacebook,
  lucideInstagram,
} from '@ng-icons/lucide';

/**
 * The icons the app draws with `<ng-icon name="solarCloseBroken" />`, registered once for the whole app (`provideIcons(APP_ICONS)` in
 * `app.config.ts`, and in `renderApp()` for the specs). They are the Solar "broken" icons of `@spartan-ng/helm/icons`, the set of the
 * Figma page "Manager"; the brand marks (Facebook, Instagram) come from lucide because Solar has none. A page that needs an icon
 * missing here registers it itself (`providers: [provideIcons({ solarCloseBroken })]`), or add it here when several pages draw it.
 */
export const APP_ICONS = {
  solarAddCircleBroken,
  solarAlignLeftBroken,
  solarAltArrowDownBroken,
  solarAltArrowLeftBroken,
  solarAltArrowRightBroken,
  solarArrowLeftBroken,
  solarArrowRightBroken,
  solarBuildings2Broken,
  solarCalendarBroken,
  solarCameraBroken,
  solarChart2Broken,
  solarChartBroken,
  solarCheckBroken,
  solarCheckCircleBroken,
  solarChecklistBroken,
  solarClockCircleBroken,
  solarCloseBroken,
  solarCloseCircleBroken,
  solarCloudCrossBroken,
  solarCloudUploadBroken,
  solarCodeBroken,
  solarCompassBroken,
  solarCopyBroken,
  solarCrownBroken,
  solarDangerTriangleBroken,
  solarDisketteBroken,
  solarDocumentTextBroken,
  solarDownloadBroken,
  solarEyeBroken,
  solarEyeClosedBroken,
  solarForbiddenCircleBroken,
  solarGalleryBroken,
  solarGalleryCheckBroken,
  solarGlassesBroken,
  solarGlobalBroken,
  solarHamburgerMenuBroken,
  solarHeartBroken,
  solarHourglassBroken,
  solarInboxBroken,
  solarInfoCircleBroken,
  solarKeyBroken,
  solarLetterBroken,
  solarLinkBroken,
  solarLockKeyholeBroken,
  solarLogoutBroken,
  solarMagicStick3Broken,
  solarMagniferBroken,
  solarMapBroken,
  solarMapPointBroken,
  solarMaximizeBroken,
  solarMenuDotsBroken,
  solarMinimizeBroken,
  solarMonitorBroken,
  solarNotebookBroken,
  solarPenBroken,
  solarPenNewSquareBroken,
  solarPieChart2Broken,
  solarPlainBroken,
  solarQrCodeBroken,
  solarRefreshBroken,
  solarRestartBroken,
  solarSettingsBroken,
  solarShareBroken,
  solarShieldUserBroken,
  solarShopBroken,
  solarSquareArrowRightUpBroken,
  solarStarBroken,
  solarTagBroken,
  solarTicketBroken,
  solarTrashBinTrashBroken,
  solarTuning2Broken,
  solarUndoLeftBroken,
  solarUndoLeftRoundBroken,
  solarUploadBroken,
  solarUserBroken,
  solarUsersGroupRoundedBroken,
  solarVideocameraBroken,
  solarWidgetBroken,
  lucideFacebook,
  lucideInstagram,
};
